import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import KPIDetailView from "./KPIDetailView";
import Profile from "./Profile";
import { fetchSession } from "./session";
import ProtectedRoute from "./components/ProtectedRoute";
import { getCurrentAgentInfo } from "./odooRpc";

function App() {
  const [session, setSession] = useState(false);
  const [isCheckingSession, setIsCheckingSession] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const data = await fetchSession();
        if (data?.authenticated) {
          if (data.email) {
            localStorage.setItem("email", data.email);
          }
          await getCurrentAgentInfo().catch(() => null);
          if (data.name && !localStorage.getItem("agent_name")) {
            localStorage.setItem("agent_name", data.name);
          }
          setSession(true);
        } else {
          localStorage.clear();
          setSession(false);
        }
      } catch (_error) {
        localStorage.clear();
        setSession(false);
      } finally {
        setIsCheckingSession(false);
      }
    };

    checkSession();
  }, []);

  if (isCheckingSession) {
    return (
      <div className="page-state">
        <div className="spinner" />
        <p>Loading session...</p>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={<Login onLogin={() => setSession(true)} />}
        />

        {session ? (
          <>
            <Route
              path="/"
              element={
                <ProtectedRoute isAuthenticated={session}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/details/:type"
              element={
                <ProtectedRoute isAuthenticated={session}>
                  <KPIDetailView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute isAuthenticated={session}>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;
